import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-my-[30xp]" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "tw-block tw-p-[10px] tw-border tw-border-solid tw-border-primary tw-text-primary tw-opacity-50"
}
const _hoisted_4 = {
  key: 2,
  class: "tw-absolute tw-top-[-12px] tw-right-[-19px]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResultMark = _resolveComponent("ResultMark")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.words, (w, key) => {
      return (_openBlock(), _createElementBlock("div", {
        key: key,
        class: "tw-relative tw-inline-block tw-m-[10px]"
      }, [
        (_ctx.results[key] === undefined)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "",
              onClick: _withModifiers(($event: any) => (_ctx.selectOption(key)), ["prevent"]),
              class: "tw-block tw-p-[10px] tw-border tw-border-solid tw-text-primary tw-border-primary tw-no-underline hover:tw-bg-primaryvlt"
            }, _toDisplayString(w.value), 9, _hoisted_2))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(w.value), 1)),
        (_ctx.results[key] !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_ResultMark, {
                result: _ctx.results[key] > 0
              }, null, 8, ["result"])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}